import { FormProvider } from 'react-hook-form';

import { ButtonType, ButtonVariant } from '@xemplo/button';
import { HeaderIconMode } from '@xemplo/header-icon';
import { DawnPeopleOnboarding } from '@xemplo/icons';
import { Modal, ModalDialogSlot } from '@xemplo/modal-dialog';

import { AssignPayrollManagerContentProps } from './assign-payroll-manager.types';
import { AssignPayrollManagerModalBody } from './assign-payroll-manager-modal-body';
import { usePayrunAssigneeModal } from './use-payrun-assignee-modal';

/**
 * Owns the form. Rendered only while the dialog is open so `useForm` re-seeds its
 * defaults from the current payrun on every open, rather than the first one.
 */
export function AssignPayrollManagerContent(props: AssignPayrollManagerContentProps) {
  const { handleSubmit, handleClose, methods } = usePayrunAssigneeModal(props);

  return (
    <FormProvider {...methods}>
      <Modal>
        <Modal.Slot
          name={ModalDialogSlot.CloseButton}
          render={
            <Modal.CloseButton
              onClick={handleClose}
              id="assign-payroll-manager-modal-close-button"
              ariaLabel="close modal"
            />
          }
        />
        <Modal.Slot
          name={ModalDialogSlot.Header}
          render={
            <Modal.Header
              title="Assign Payroll Manager"
              headerIcon={{
                icon: <DawnPeopleOnboarding />,
                mode: HeaderIconMode.Object,
              }}
            />
          }
        />
        <Modal.Slot
          name={ModalDialogSlot.Body}
          render={
            <Modal.Body>
              <AssignPayrollManagerModalBody payrun={props.payrun} />
            </Modal.Body>
          }
        />
        <Modal.Slot
          name={ModalDialogSlot.Footer}
          render={
            <Modal.Footer
              btnPrimary={{
                onClickAsync: handleSubmit,
                label: 'Assign',
                ariaLabel: 'Assign',
                type: ButtonType.Primary,
              }}
              btnTertiary={{
                onClick: handleClose,
                label: 'Cancel',
                ariaLabel: 'Cancel',
                type: ButtonType.Tertiary,
                variant: ButtonVariant.Dark,
              }}
            />
          }
        />
      </Modal>
    </FormProvider>
  );
}
